/*
  Миксин с периодической подгрузкой данных для виджетов
*/

import {Component, Vue} from 'vue-property-decorator';

@Component
export default class WidgetDataTimerMixin extends Vue {
  protected getDataTimeout!: number;

  private timerId: number | undefined;

  protected async refresh(callback: any) {
    await callback();
    this.timerId = setTimeout(() => {
      this.refresh(callback);
    }, this.getDataTimeout * 1000);
  }

  protected clearRefresh() {
    clearTimeout(this.timerId);
  }

  beforeDestroy() {
    this.clearRefresh();
  }
}
